export default {
  /*查询视图基本信息*/
  getViewInfo(viewDisplayConfId: any) {
    return `/api/appproc/form-view/${viewDisplayConfId}/basic-info`;
  },
  /*获取查询条件*/
  getConditions(viewDisplayConfId: any) {
    return `/api/appproc/data-view-query-config/${viewDisplayConfId}`;
  },
  /*查询动态表单*/
  getTableData() {
    return `/api/appproc/form-view/dynamic-form/search`;
  },
  /*删除视图表单数据*/
  delTableData(data: any) {
    return `/api/appproc/form-view/${data.dataViewCfgId}/dynamic-form/${data.businessId}`;
  },
  /*初始流程数据查询*/
  flowInitRead: () => {
    return `/api/appproc/read/business/fresh-read`;
  },
  /*新增视图表单数据*/
  createDyForm() {
    return `/api/appproc/form-view/dynamic-form/create`;
  },
  /*查询视图表单详情*/
  getDyForm() {
    return `/api/appproc/form-view/form-detail`;
  },
  /*更新视图表单数据*/
  updDyForm() {
    return `/api/appproc/form-view/dynamic-form`;
  },
  /*用户上传附件（多文件）*/
  mulUploadFiles: "/api/attachments/multi-upload",
  /*下载附件*/
  downLoadFiles(data: any) {
    return `/api/appproc/form-view/${data.viewDisplayConfId}/dynamic-form/${data.businessId}/attachment-zip`;
  },
  /*获取视图主查询条件渲染树*/
  getPrimarySearchTree(viewDisplayConfId: string) {
    return `/api/appproc/form-view/${viewDisplayConfId}/primary-search-tree`;
  },
  /*获取视图主查询参数语句 */
  getPrimarySearchSql(viewDisplayConfId: string) {
    return `/api/appproc/form-view/${viewDisplayConfId}/primary-search-tree/search-params`;
  }
};

